module.exports = __webpack_public_path__ + "static/media/modern-editor-3A.1e3a170a.png";